// extracted by mini-css-extract-plugin
export default {"MinMax":"EditionConstante_MinMax__pvafh"};